// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".longHeight{height:100%!important}.selectedReceiverBox{height:calc(100% - 100px);width:100%;margin-top:5px;overflow-y:scroll;padding:10px;background-color:#fff;text-align:left}[contenteditable=true],input:focus{outline:none}", ""]);
// Exports
module.exports = exports;
